// PecuNovus JSON-RPC bridge endpoint (pecu-rpc-service-erc20).
// The dispatcher answers JSON-RPC 2.0 on POST / of this host.
// Matches config/swagger.js's production server entry.
const rpcUrl = "https://mainnet.pecunovus.net";
export default rpcUrl;
